import { SummaryPaneResult } from 'src/apps/mobile-common/types/CommonTypes';
import { returnNonNull } from 'src/common/helpers/ArraysHelper';

import { MfaSessionSummaryQuery } from '../MfaSessionSummary.generated';

export const transformMfaSessionSummaryResults = (
	rawResults: MfaSessionSummaryQuery
): SummaryPaneResult | null => {
	const sessionData = rawResults.mfa_session_runs?.filter(returnNonNull)?.[0];

	if (!sessionData) {
		return null;
	}

	// Get actual scan counts by platform from the scans query
	const androidScans = rawResults.androidScans?.[0]?.os_count || 0;
	const iosScans = rawResults.iosScans?.[0]?.os_count || 0;

	// Calculate average per scan
	const totalScans = sessionData.total_scans;
	const totalIssues = sessionData.total_issues;
	const averagePerScan = totalScans > 0 ? Math.round(totalIssues / totalScans) : 0;

	// Calculate addedToJira from the issues data
	const issues = rawResults.issues?.filter(returnNonNull) || [];
	const issuesWithTickets = issues.filter((issue) => {
		const ticketKeys = issue.tickets__key || [];
		return ticketKeys.length > 0 && ticketKeys.some((key) => key && key.trim() !== '');
	});
	const addedToJira = issuesWithTickets.length;

	return {
		totalScans,
		totalIssues,
		averagePerScan,
		addedToJira,
		androidScans,
		iosScans,
		criticalIssues: sessionData.critical_issues,
		hasIosScans: iosScans > 0,
		hasAndroidScans: androidScans > 0
	};
};
